import React from 'react';

import { Provider } from 'react-redux';
import configureStore from 'redux-mock-store';

import {
	TestCoreComponentProps,
	TestCoreComponent as TestCoreComponentShared,
} from '@bcp-channels-sharedcomponents-reactjs/core';
import { Company, Language, Platform } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { initialStateMock } from '@store';
import { Anything } from '@types';

// to fix not exists children prop in react-18
const TestCoreComponent = TestCoreComponentShared as any;

export interface TestComponentProps {
	state?: Record<string, Anything>;
	coreProps?: TestCoreComponentProps;
	children: React.ReactNode;
}

export const TestComponent: React.FC<TestComponentProps> = ({ children, state = {}, coreProps }) => {
	coreProps = coreProps
		? coreProps
		: {
				company: Company.bcp,
				language: Language.pt,
				platform: Platform.mobile,
		  };

	const mockStore = configureStore();
	const store = mockStore({
		...initialStateMock,
		...state,
	});

	return (
		<Provider store={store}>
			<TestCoreComponent data-test="test-component" {...coreProps}>
				{children}
			</TestCoreComponent>
		</Provider>
	);
};
